import { SVGIconName } from '../svgIcon';

export enum MultiplayerGameType {
  JOYAChess = 'joyachess',
  //
  FiveLoavesTwoFish = 'fiveLoavesTwoFish',
  TicTacToe = 'ticTacToe',
  Gomoku = 'gomoku',
  Go = 'go',
  Chess = 'chess',
  ChineseChess = 'chineseChess',
}

type GameInfo = {
  name: string;
  icon: SVGIconName;
};

const multiplayerGameTypeMap = new Map<MultiplayerGameType, GameInfo>([
  [
    MultiplayerGameType.JOYAChess,
    {
      name: 'JOYAJOY AI Chess',
      icon: 'JOYChess',
    },
  ],
  [
    MultiplayerGameType.FiveLoavesTwoFish,
    {
      name: 'Five Loaves Two Fish',
      icon: 'FiveLoavesTwoFish',
    },
  ],
  [MultiplayerGameType.TicTacToe, { name: 'Tic Tac Toe', icon: 'TicTacToe' }],
  [MultiplayerGameType.Gomoku, { name: 'Gomoku', icon: 'Gomoku' }],
  [MultiplayerGameType.Go, { name: 'GO', icon: 'JOYChess' }],
  [MultiplayerGameType.Chess, { name: 'CHESS', icon: 'JOYChess' }],
  [
    MultiplayerGameType.ChineseChess,
    { name: 'Chinese CHESS', icon: 'JOYChess' },
  ],
]);

export const getMultiplayerGameTypeInfo = (
  gameType: MultiplayerGameType,
): GameInfo => {
  return (
    multiplayerGameTypeMap.get(gameType) || {
      name: 'Unknown Game',
      icon: 'JOYChess',
    }
  );
};
